export function setLocalStorage(key, value, access) {
  if (access) { localStorage.setItem(key, value); }
  return value;
}


//////////////////
// WEBPACK FOOTER
// ../work/src/~/tiny-slider/src/helpers/setLocalStorage.js
// module id = 46
// module chunks = 0